const Header = props => {

	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
			<div className="lg:text-center">
				<h2 className="text-base text-[#f3733b] font-semibold tracking-wide uppercase text-center">Multipoint Inspections Of Your Firm's Digital Presence</h2>
				<p className="my-4 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl text-center">
					Get a <span className="mx-1 before:block before:absolute before:-inset-1 before:-skew-y-3 before:bg-[#17837e] relative inline-block">
   								 <span className="relative text-white">FREE</span>
  								</span> Instant Audit
				</p>
				<p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto text-center">
					Enter your domain below to test your website
				</p>
			</div>
		</div>
	);
};

export default Header;